<template>
  <div class="bg-white p-4 rounded-lg mt-4 text-textPrimary">
    <h2 class="text-md font-bold text-left mb-4">Valor acordado</h2>
    <div class="grid grid-cols-2 gap-y-4 gap-x-4 text-textPrimary">
      <div class="text-left">
        <h3 class="text-sm font-bold">Valor por hora</h3>
        <p class="mt-1 text-sm">{{ formatCurrency(props.originalHourlyValue) }}</p>
      </div>

      <div class="text-left">
        <h3 class="text-sm font-bold">Valor original do plantão</h3>
        <p class="mt-1 text-sm">
          {{ formatCurrency(props.originalHourlyValue * props.baseDuration) }}
        </p>
      </div>

      <div class="text-left">
        <h3 class="text-sm font-bold">Custo base</h3>
        <p class="mt-1 text-sm">
          {{ props.baseCost === null ? '—' : formatCurrency(props.baseCost) }}
        </p>
      </div>

      <div class="text-left">
        <h3 class="text-sm font-bold">Custo excepcional</h3>
        <p class="mt-1 text-sm">
          {{ props.exceptionalCost === null ? '—' : formatCurrency(props.exceptionalCost) }}
        </p>
      </div>

      <div class="text-left">
        <h3 class="text-sm font-bold">Prejuízo Previsto</h3>
        <p class="mt-1 text-sm" :class="'text-negative'">
          {{ props.estimatedLossTotal === null ? '—' : formatCurrency(props.estimatedLossTotal) }}
        </p>
      </div>

      <!-- Fica na coluna de "Custo excepcional", logo abaixo dele. Omitido quando o
      caller não informa a prop (a sidebar de detalhe ainda não passa o valor). -->
      <div
        v-if="props.totalExceptionalValue !== undefined"
        class="text-left"
        data-testid="exception-agreed-value-total-requested"
      >
        <h3 class="text-sm font-bold">Valor total solicitado</h3>
        <p class="mt-1 text-sm font-bold">
          {{
            props.totalExceptionalValue === null ? '—' : formatCurrency(props.totalExceptionalValue)
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  originalHourlyValue: number
  exceptionalCost: number | null
  baseCost: number | null
  estimatedLossTotal: number | null
  baseDuration: number
  exceptionalDuration: number
  /** Valor que o médico recebe pelo plantão excepcional (`financials.totalExceptionalValue`),
   * sem a taxa de crédito à vista. */
  totalExceptionalValue?: number | null
}>()
const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value)
}
</script>
